import styled from '@emotion/styled';

export const SearchWrapper = styled.div`
  width: 568px;
`;

export const FiltersWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Filter = styled.div`
  display: flex;
  align-items: center;

  label {
    margin-right: 0.8rem;
  }
`;

export const NoResultMessage = styled.div`
  text-align: center;
  margin-top: 1rem;

  span {
    color: ${({ theme }) => theme.colors.action};
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
  }
`;
